/* eslint-disable max-lines-per-function */
import { useState, useRef, useEffect } from "react";
import { cn } from "tailwind-variants";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import "./ArtworkFeedbackModal.scss";
import { renderList } from "common/vue/render-list";

const FEEDBACK_OPTIONS = [
  {
    value: "Background Removal",
    label: "Background Removal"
  },
  {
    value: "Image Blurriness",
    label: "Image Blurriness"
  }
];

export default function ArtworkFeedbackModal({
  onSubmit: onSubmitProp,
  onClose: onCloseProp,
  ...restProps
}) {
  const modalRef = useRef(null);
  const [selectedReason, setSelectedReason] = useState(null);
  const [closed, setClosed] = useState(false);

  function options() {
    return FEEDBACK_OPTIONS;
  }

  function handleClose() {
    $(document).off("keydown.feedbackModal");
    $(modalRef.current).modal("hide");
    setClosed(true);
    setSelectedReason(null);
    onCloseProp();
  }

  function handleSubmit() {
    if (selectedReason) {
      onSubmitProp(selectedReason);
      $(modalRef.current).modal("hide");
      setClosed(true);
      setSelectedReason(null);
    }
  }

  function onShow() {
    const $modal = $(modalRef.current);
    $modal.modal("show").on("hidden.bs.modal", () => {
      $modal.off("hidden.bs.modal");
      if (!closed) {
        onCloseProp();
      }
    });
    $(document).on("keydown.feedbackModal", e => {
      if (e.key === "Escape") {
        handleClose();
      }
    });
  }

  useEffect(() => {
    onShow();
  }, []);

  return (
    <div
      {...restProps}
      className={cn("modal artwork-feedback-modal scope-03adaafb", restProps.className)}
      ref={modalRef}
      role="dialog"
      data-testid="modal"
    >
      <div className="artwork-feedback-modal__modal-box modal-dialog scope-03adaafb">
        <div className="artwork-feedback-modal__modal-header scope-03adaafb">
          <div className="artwork-feedback-modal__header-content scope-03adaafb">
            <h2 className="artwork-feedback-modal__modal-title scope-03adaafb">
              Let's make it right!
            </h2>
            <h3 className="artwork-feedback-modal__modal-subtitle scope-03adaafb">
              {" "}
              Tell us what didn't go as expected so we can fix it.{" "}
            </h3>
          </div>
          <button
            className="artwork-feedback-modal__modal-button-close scope-03adaafb"
            type="button"
            onClick={handleClose}
            data-testid="artwork-feedback-modal-modal-button-close"
          >
            <UseSvg
              className="artwork-feedback-modal__close-icon scope-03adaafb"
              icon="modal-close-big"
              data-testid="artwork-feedback-modal-close-icon"
            />
          </button>
        </div>
        <div className="artwork-feedback-modal__modal-body scope-03adaafb">
          <fieldset
            className="artwork-feedback-modal__fieldset scope-03adaafb"
            aria-labelledby="artwork-feedback-legend"
            data-testid="artwork-feedback-modal-fieldset"
          >
            <legend
              className="artwork-feedback-modal__legend scope-03adaafb"
              id="artwork-feedback-legend"
              data-testid="artwork-feedback-modal-legend"
            >
              {" "}
              Please choose primary issue:{" "}
            </legend>
            <div className="artwork-feedback-modal__options-container scope-03adaafb">
              <div className="artwork-feedback-modal__options scope-03adaafb">
                {renderList(options(), option => (
                  <label
                    className="artwork-feedback-modal__option scope-03adaafb"
                    key={option.value}
                    data-testid="artwork-feedback-modal-option"
                  >
                    <input
                      className="artwork-feedback-modal__radio scope-03adaafb"
                      type="radio"
                      checked={selectedReason === option.value}
                      onInput={e => {
                        setSelectedReason(e.target.value);
                      }}
                      value={option.value}
                      name="artwork-feedback"
                      data-testid="artwork-feedback-modal-radio"
                    />
                    <span className="artwork-feedback-modal__option-label scope-03adaafb">
                      {option.label}
                    </span>
                  </label>
                ))}
              </div>
            </div>
          </fieldset>
        </div>
        <div className="artwork-feedback-modal__modal-footer scope-03adaafb">
          <div className="artwork-feedback-modal__actions scope-03adaafb">
            <button
              className="artwork-feedback-modal__cancel scope-03adaafb"
              type="button"
              onClick={handleClose}
              data-testid="artwork-feedback-modal-cancel"
            >
              {" "}
              Cancel{" "}
            </button>
            <button
              className="artwork-feedback-modal__submit scope-03adaafb"
              type="button"
              disabled={!selectedReason}
              onClick={handleSubmit}
              data-testid="artwork-feedback-modal-submit"
            >
              {" "}
              Send Feedback{" "}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
